module.exports = __webpack_public_path__ + "static/media/me-6.7976769a.svg";